import jwtDecode from 'jwt-decode'
import { getSessionToken } from '~/features/auth'

import { get } from '@hap/utils'

import { getConfigValue } from './envHelpers'

interface Session {
  iat: number
  id: string
  email?: string
  oui?: Record<ID, ID>
  orgOpts?: Record<ID, { limited: boolean; wfIds: ID[] }>
  imp?: {
    sessionId: string
    orgLegacyId: string
    impersonatorUserId: string
    impersonatedUserId: string
  }
}

export const getOrganizationIdFromUrl = (): string => {
  return window.HAP_CURRENT_ORGANIZATION_LEGACY_ID
}

export const getOrganizationIdFallbackFromUrl = (): string => {
  const organizationParam = window.location.pathname.match(/\/org\/([\w\d]+)/i)
  const organizationId: string = organizationParam ? organizationParam[1] : ''
  return organizationId
}

export const getOrganizationAliasFromUrl = (): string => {
  const aliasParam = window.location.pathname.match(/\/([\w\d-]+)/i)
  const alias: string = aliasParam ? aliasParam[1] : ''
  return alias
}

export const getAuthToken = (
  location?: 'cookie' | 'localStorage',
): string | null | undefined =>
  location === 'localStorage' ? window.localStorage.getItem('auth') : getSessionToken()

export const unpackAuthToken = (token?: Nullable<string>): Session | null => {
  try {
    return token ? jwtDecode(token) : null
  } catch (e) {
    return null
  }
}

interface AuthenticationOptions {
  workflowId?: ID
}

export const isAuthenticated = (
  organizationId: ID,
  token?: string | null,
  opts: AuthenticationOptions = {},
): boolean => {
  if (!token) return false
  const unpackedToken = unpackAuthToken(token)
  if (get(unpackedToken, ['orgOpts', organizationId, 'limited'])) {
    // Check if limited user has access to the workflow
    return (
      !!opts.workflowId &&
      // @ts-ignore
      get(unpackedToken, ['orgOpts', organizationId, 'wfIds']).includes(opts.workflowId)
    )
  }
  if (get(unpackedToken, ['oui', organizationId])) return true
  return false
}

export const hasSessionCookie = (): boolean => !!getAuthToken()

export const redirectToLogin = (organizationId?: ID): void => {
  window.location.replace(
    `${getConfigValue('VITE_LOGIN_ROUTE')}/${
      organizationId ? `?orgId=${organizationId}` : ''
    }`,
  )
}
